<template>

  <el-dialog title="会员等级" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :label-width="formLabelWidth">
      <el-form-item label="推荐人等级" prop="user_name">
        <el-select v-model="form.referee_grade_id" placeholder="-默认等级-">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="被邀请人等级" prop="role_id">
        <el-select v-model="form.invited_grade_id">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="有效次数" prop="num">
        <el-input v-model="form.num" placeholder="请输入有效次数" type="number"></el-input>
      </el-form-item>
      <el-form-item label="推荐奖励" prop="money">
        <el-input v-model="form.money" placeholder="请输入确认金额" type="number"></el-input>
      </el-form-item>
      <el-form-item label="关联商品" prop="product_id">
         <template>
           <el-row>
          <div class="d-s-c f-w">
            <div v-for="(product, index) in form.productList" class="img pr" :key="product.product_id">
              <div class="delete-box"><i class="el-icon-error" @click="$parent.deleteFunc(index)"></i></div>
              <img v-img-url="product.product_image" width="100" height="100" alt="" />
            </div>
          </div>
           </el-row>
          <div>
            <el-button icon="el-icon-plus" @click.stop="$parent.openProduct(form.productList,true)">选择产品</el-button>
          </div>
        </template>
      <!--组件样式-->
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PlusApi from '@/api/plus.js';
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['open','form','gradeList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    },
  },
  created() {},
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      PlusApi.rulesSave(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/dialog/Edit.vue